import React from "react";
import {graphql} from "gatsby";
import {Helmet} from "react-helmet";
import Masonry from "react-masonry-css";

import PaginationLinks from "../common/PaginationLinks";
import PublicationLink from "./PublicationLink";

import * as classes from "./Publications.module.scss";

export default function Publications({data, pageContext: {humanPageNumber, previousPagePath, nextPagePath}}) {

    const edges = data["allPublication"]["edges"];

    return (
        <section>
            <Helmet>
                <title>Наши публикации{humanPageNumber > 1 ? `, страница ${humanPageNumber}` : ""}</title>
                <meta name="description" content="Научная деятельность, статьи, публикации, доклады на конференциях сотрудников «РУССЭЛЛ»." />
            </Helmet>
            <h1>Наши публикации</h1>
            <Masonry
                className={classes.masonryGrid}
                columnClassName={classes.masonryGridColumn}
                breakpointCols={2}>
                {edges?.map(({node}) =>
                    <PublicationLink
                        key={node.id}
                        className={classes.link}
                        title={node["title"]}
                        link={node["link"]}
                        document={node["document"]?.["publicURL"]} />)}
            </Masonry>
            <PaginationLinks
                previousLinkText="Показать более свежие публикации"
                nextLinkText="Показать более ранние публикации"
                previousLinkTo={previousPagePath}
                nextLinkTo={nextPagePath} />
        </section>
    );

}

export const query = graphql`
    query($skip: Int, $limit: Int) {
        allPublication(
            sort: {fields: [timestamp], order: DESC}
            skip: $skip
            limit: $limit
        ) {
            edges {
                node {
                    ...PublicationLink
                }
            }
        }
    }
`;
